<template>
    <div class="filter__chapter">
        <h3>Filter By Chapter</h3>
        <div class="chapter-filter">
            <div class="chapter-filter__item">
                <input type="checkbox" id="global" value="0" name="global" @change="update" v-model="checkedChapters">
                <label for="global">
                    {{ nameForGlobal }}
                </label>
            </div>
            <div v-for="chapter in chapters" :key="chapter.id" class="chapter-filter__item">
                <input type="checkbox" :id="chapter.slug" :value="chapter.id" :name="chapter.slug" @change="update" v-model="checkedChapters">
                <label :for="chapter.slug">
                    {{ chapter.title }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
       data() {
           return {
               checkedChapters: [],
           }
       },
       props: ['chapters','nameForGlobal'],
       methods: {
           update(){
               this.$emit('chaptersChanged',this.checkedChapters.map(v=>parseInt(v)));
           }
       }

    }
</script>